import { useTranslation } from "next-i18next";
import styles from "./card-part-number.module.scss";

const CardPartNumber = ({ product = {} }: any) => {
  const { t } = useTranslation("common");

  return (
    <div>

      <span className={styles.item_part_label}>
        {t("Part")}
        &nbsp;
        #:
        &nbsp;
      </span>

      <span className={styles.item_part_number}>{product.partNumber}</span>
    </div>
  );
};

export default CardPartNumber;
